"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CGJText = void 0;
const KHMenuOption_1 = require("./KH/Menu/KHMenuOption");
class CGJText extends Phaser.GameObjects.Text {
    constructor(scene, width, height, xPercent, yPercent, menuOption, fontSizePercent, pointer_over, pointer_out, pointer_left, pointer_right) {
        // const text = this.add.text(w * cx, h * cy, option_text, { fontFamily: 'NovaMono,Monospace', color: '#FFFFFF', align:'center'}).setFontSize(h * size).setDepth(1);
        super(scene, xPercent * width, yPercent * height, menuOption.getText(), { fontFamily: 'NovaMono,Monospace', color: '#FFFFFF', align: 'center' });
        this.setOrigin(0.5, 0.5);
        this.setShadow(5, 5);
        this.xPercent = xPercent;
        this.yPercent = yPercent;
        this.fontSizePercent = fontSizePercent;
        this.menuOption = menuOption;
        this.updateTextValue();
        this.updateSelected();
        menuOption.registerCallback(KHMenuOption_1.KHMenuOption.UPDATE_TEXT, (data) => {
            this.updateText();
        });
        menuOption.registerCallback(KHMenuOption_1.KHMenuOption.UPDATE_SELECTABLE, (data) => {
            this.updateSelectable();
        });
        menuOption.registerCallback(KHMenuOption_1.KHMenuOption.UPDATE_SELECTED, (data) => {
            this.updateSelected();
        });
        this.on('pointerover', () => {
            if (pointer_over)
                pointer_over();
        });
        this.on('pointerout', () => {
            if (pointer_over)
                pointer_out();
        });
        this.on('pointerdown', (pointer) => {
            if (pointer.rightButtonDown()) {
                if (pointer_right)
                    pointer_right();
            }
            else if (pointer.leftButtonDown()) {
                if (pointer_left)
                    pointer_left();
            }
        });
        this.resize(width, height);
    }
    resize(w, h) {
        this.setFontSize(this.fontSizePercent * h);
        this.x = this.xPercent * w;
        this.y = this.yPercent * h;
        this.updateSelectable();
    }
    updateTextValue() {
        this.setText(this.menuOption.getText());
    }
    updateSelectable() {
        if (this.menuOption.getSelectable()) {
            const bounds = this.getBounds();
            this.setInteractive(new Phaser.Geom.Rectangle(0, 0, bounds.width, bounds.height), Phaser.Geom.Rectangle.Contains);
        }
        else {
            this.removeInteractive();
        }
    }
    updateSelected() {
        if (this.menuOption.getSelected()) {
            this.setColor('#FFFF00');
            this.dirty = true;
        }
        else {
            this.setColor('#FFFFFF');
            this.dirty = true;
        }
    }
}
exports.CGJText = CGJText;
CGJText.EVENT_SELECTED = "s";
